import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { MenuItem, Typography } from "@mui/material"
import { TimePicker, renderTimeViewClock } from "@mui/x-date-pickers"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { CreateOrEditShopFormValues } from "../../shopsTypes"

const useStyles = makeStyles()((theme) => ({
    deadlineTitle: {
        color: theme.palette.tailwind.slate[600],
    },
}))

export const dayOptions = Array.from({ length: 14 }, (v, i) => ({
    value: i + 1,
    label: i === 0 ? "The day before" : `${i + 1} days before`,
}))

type DeadlineFieldProps = Readonly<{}>

export function DeadlineField({}: DeadlineFieldProps) {
    const { values, setFieldValue } = useFormikContext<CreateOrEditShopFormValues>()
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="merchant-shop-form-purchases">
                <Typography variant="subtitle2" className={classes.deadlineTitle}>
                    Purchases:
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-shop-form-deadline-day-field" attrs={{ label: true }}>
                <FormikDropdown name="deadline.purchases.daysBefore" label="Day" fullWidth>
                    {dayOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            <LocalizedStrict
                                id={
                                    option.value === 1
                                        ? "merchant-shop-form-deadline-day-limit-day-before"
                                        : "merchant-shop-form-deadline-day-limit-x-days-before"
                                }
                                vars={{ daysBefore: option.value }}
                            >
                                <span>{option.value}</span>
                            </LocalizedStrict>
                        </MenuItem>
                    ))}
                </FormikDropdown>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-shop-form-deadline-time-picker" attrs={{ label: true }}>
                <TimePicker
                    viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                    }}
                    minutesStep={5}
                    value={values?.deadline?.purchases?.timeOfDay}
                    onChange={(newValue) => {
                        if (newValue) {
                            setFieldValue("deadline.purchases.timeOfDay", newValue)
                        }
                    }}
                    label="Time"
                />
            </LocalizedStrict>
            <LocalizedStrict id="merchant-shop-form-cancellation">
                <Typography variant="subtitle2" className={classes.deadlineTitle}>
                    Cancellation:
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-shop-form-deadline-day-field" attrs={{ label: true }}>
                <FormikDropdown name="deadline.cancellation.daysBefore" label="Day" fullWidth>
                    {dayOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            <LocalizedStrict
                                id={
                                    option.value === 1
                                        ? "merchant-shop-form-deadline-day-limit-day-before"
                                        : "merchant-shop-form-deadline-day-limit-x-days-before"
                                }
                                vars={{ daysBefore: option.value }}
                            >
                                <span>{option.value}</span>
                            </LocalizedStrict>
                        </MenuItem>
                    ))}
                </FormikDropdown>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-shop-form-deadline-time-picker" attrs={{ label: true }}>
                <TimePicker
                    viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                    }}
                    minutesStep={5}
                    value={values?.deadline?.cancellation?.timeOfDay}
                    onChange={(newValue) => {
                        if (newValue) {
                            setFieldValue("deadline.cancellation.timeOfDay", newValue)
                        }
                    }}
                    label="Time"
                />
            </LocalizedStrict>
        </>
    )
}
